module.exports = __webpack_public_path__ + "media/images/footer_facebook-3c7152c2.png";